import { useSelector } from 'react-redux';
import { signInServiceName as signInServiceNameSelector } from '~/platform/user/authentication/selectors';
import { SERVICE_PROVIDERS } from '~/platform/user/authentication/constants';

// DS Logon was removed from platform SERVICE_PROVIDERS but is still needed
// for credential retirement messaging until the retirement is complete.
const DS_LOGON_PROVIDER = { label: 'DS Logon', link: '' };

export const useSignInServiceProvider = () => {
  const signInServiceName = useSelector(signInServiceNameSelector);

  const { link, label } =
    SERVICE_PROVIDERS[signInServiceName] ||
    (signInServiceName === 'dslogon' ? DS_LOGON_PROVIDER : {});
  return { signInServiceName, link, label };
};
